import SmallHeadingComponent from "../component/SmallHeadingComponent"
import SmallestHeadingComponent from "../component/SmallestHeadingComponent"

function LegalView() {
    return (
        <div className={"w-full flex justify-center my-20"}>
            <div className={"max-w-[1000px] flex flex-col space-y-10"}>
                <SmallHeadingComponent>Impressum</SmallHeadingComponent>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Technische Umsetzung
                    </SmallestHeadingComponent>
                    <div>
                        Dieser Webauftritt ist mit der Frontend-Technologie
                        React und der Backend-Technologie Express umgesetzt. Es
                        handelt sich dabei um ein Angebot der TUM im Rahmen der
                        Promotion von Philipp-Reindl Spanner.
                    </div>
                    <div>
                        Technischer Ansprechpartner für dieses Angebot und
                        Verantwortlicher für den Einbau und Verwaltung der
                        Inhalte ist Philipp Reindl-Spanner - erreichbar unter
                        philipp.spanner@tum.de
                    </div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Herausgeber
                    </SmallestHeadingComponent>
                    <div>Technische Universität München</div>
                    <div>Arcisstraße 21</div>
                    <div>80333 München</div>
                    <div>Telefon: +4989289-01</div>
                    <div>poststelle@tum.de</div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Rechtsform und Vertretung
                    </SmallestHeadingComponent>
                    <div>
                        Die Technische Universität München ist eine Körperschaft
                        des Öffentlichen Rechts und staatliche Einrichtung (Art
                        4 Abs 1 BayHIG). Sie wird gesetzlich vertreten durch den
                        Präsidenten Prof. Dr. Thomas F. Hofmann.
                    </div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Zuständige Aufsichtsbehörde
                    </SmallestHeadingComponent>
                    <div>
                        Bayerisches Staatsministerium für Wissenschaft und Kunst
                    </div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Umsatzsteueridentifikationsnummer
                    </SmallestHeadingComponent>
                    <div>DE811193231(gemäß § 27a Umsatzsteuergesetz)</div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Inhaltlich verantwortlich
                    </SmallestHeadingComponent>
                    <div>
                        <b>Prof. Dr. Dr. h.c. Helmut Krcmar</b>
                    </div>
                    <div>Boltzmannstraße 3</div>
                    <div>85748 Garching bei München</div>
                    <div>
                        Namentlich gekennzeichnete Internetseiten geben die
                        Auffassungen und Erkenntnisse der genannten Personen
                        wieder.
                    </div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Nutzungsbedingungen
                    </SmallestHeadingComponent>
                    <div>
                        Texte, Bilder, Grafiken sowie die Gestaltung dieses
                        Webauftritts können dem Urheberrecht unterliegen. Nicht
                        urheberrechtlich geschützt sind nach § 5 des
                        Urheberrechtsgesetz (UrhG) • Gesetze, Verordnungen,
                        amtliche Erlasse und Bekanntmachungen sowie
                        Entscheidungen und amtlich verfasste Leitsätze zu
                        Entscheidungen und • andere amtliche Werke, die im
                        amtlichen Interesse zur allgemeinen Kenntnisnahme
                        veröffentlicht worden sind, mit der Einschränkung, dass
                        die Bestimmungen über Änderungsverbot und Quellenangabe
                        in § 62 Abs. 1 bis 3 und § 63 Abs. 1 und 2 UrhG
                        entsprechend anzuwenden sind. Als Privatperson dürfen
                        Sie urheberrechtlich geschütztes Material zum privaten
                        und sonstigen eigenen Gebrauch im Rahmen des § 53 UrhG
                        verwenden. Eine Vervielfältigung oder Verwendung
                        urheberrechtlich geschützten Materials dieser Seiten
                        oder Teilen davon in anderen elektronischen oder
                        gedruckten Publikationen und deren Veröffentlichung ist
                        nur mit unserer Einwilligung gestattet. Diese
                        Einwilligung erteilen auf Anfrage die für den Inhalt
                        Verantwortlichen. Der Nachdruck und die Auswertung von
                        Pressemitteilungen und Reden sind mit Quellenangabe
                        allgemein gestattet. Weiterhin können Texte, Bilder,
                        Grafiken und sonstige Dateien ganz oder teilweise dem
                        Urheberrecht Dritter unterliegen. Auch über das Bestehen
                        möglicher Rechte Dritter geben Ihnen die für den Inhalt
                        Verantwortlichen nähere Auskünfte.
                    </div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>
                        Haftungsausschluss
                    </SmallestHeadingComponent>
                    <div>
                        Alle in diesem Webauftritt bereitgestellten
                        Informationen haben wir nach bestem Wissen und Gewissen
                        erarbeitet und geprüft. Eine Gewähr für die jederzeitige
                        Aktualität, Richtigkeit, Vollständigkeit und
                        Verfügbarkeit der bereit gestellten Informationen können
                        wir allerdings nicht übernehmen. Ein Vertragsverhältnis
                        mit den Nutzern des Webauftritts kommt nicht zustande.
                        Wir haften nicht für Schäden, die durch die Nutzung
                        dieses Webauftritts entstehen. Dieser Haftungsausschluss
                        gilt nicht, soweit die Vorschriften des § 839 BGB
                        (Haftung bei Amtspflichtverletzung) einschlägig sind.
                        Für etwaige Schäden, die beim Aufrufen oder
                        Herunterladen von Daten durch Schadsoftware oder der
                        Installation oder Nutzung von Software verursacht
                        werden, übernehmen wir keine Haftung.
                    </div>
                </div>
                <div className={"flex flex-col space-y-3"}>
                    <SmallestHeadingComponent>Links</SmallestHeadingComponent>
                    <div>
                        Von unseren eigenen Inhalten sind Querverweise („Links“)
                        auf die Webseiten anderer Anbieter zu unterscheiden.
                        Durch diese Links ermöglichen wir lediglich den Zugang
                        zur Nutzung fremder Inhalte nach § 8 Telemediengesetz.
                        Bei der erstmaligen Verknüpfung mit diesen
                        Internetangeboten haben wir diese fremden Inhalte
                        daraufhin überprüft, ob durch sie eine mögliche
                        zivilrechtliche oder strafrechtliche Verantwortlichkeit
                        ausgelöst wird. Wir können diese fremden Inhalte aber
                        nicht ständig auf Veränderungen überprüfen und daher
                        auch keine Verantwortung dafür übernehmen. Für illegale,
                        fehlerhafte oder unvollständige Inhalte und insbesondere
                        für Schäden, die aus der Nutzung oder Nichtnutzung von
                        Informationen Dritter entstehen, haftet allein der
                        jeweilige Anbieter der Seite.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LegalView
